import { schema } from 'normalizr';

export const ENTITY_CUSTOMER_JOBS = 'customerJobs';
export const ENTITY_CUSTOMER_JOBS_LIST = 'customerJobsList';

export const ENTITY_OPTIONS = 'options';

export const ENTITY_CUSTOMER_ESTIMATES = 'customerEstimates';
export const ENTITY_CUSTOMER_ESTIMATES_LIST = 'customerEstimatesList';

const customerJobsSchema = new schema.Entity(ENTITY_CUSTOMER_JOBS, {});
export const customerJobsListSchema = new schema.Entity(ENTITY_CUSTOMER_JOBS_LIST, { data: [customerJobsSchema] });

const optionsSchema = new schema.Entity(ENTITY_OPTIONS, {});

const customerEstimatesSchema = new schema.Entity(ENTITY_CUSTOMER_ESTIMATES, { options: [optionsSchema] });
export const customerEstimatesListSchema = new schema.Entity(
  ENTITY_CUSTOMER_ESTIMATES_LIST, { data: [customerEstimatesSchema] },
);
